var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import "./PrimitiveComponent";
import "./ReferenceComponent";
import { defaults } from "../style";
let SubElementComponent = class SubElementComponent extends LitElement {
    render() {
        if (this.el instanceof Array && this.el[0] === "REF") {
            return html `<tc-reference .el=${this.el}></tc-reference>`;
        }
        else {
            return html `<tc-primitive .el=${this.el}></tc-primitive>`;
        }
    }
};
SubElementComponent.styles = [defaults];
__decorate([
    property({ type: Array })
], SubElementComponent.prototype, "el", void 0);
SubElementComponent = __decorate([
    customElement('tc-sub-element')
], SubElementComponent);
export { SubElementComponent };
//# sourceMappingURL=SubElementComponent.js.map